import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { BorrowerSetupToDo } from './borrowerSetupToDo';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type BorrowerSetupToDoDialogProps = {
  open: boolean;
  borrowerId: number;
  loan?: any;
  handleClose: () => void;
  refreshLoan?: () => void;
  document: Document;
};

export const BorrowerSetupToDoDialog = observer((props: BorrowerSetupToDoDialogProps) => {
  const { open, borrowerId, loan, handleClose, refreshLoan, document } = props;
  const taskId = document?.taskId;

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          maxWidth={'lg'}
          open={open}
          title='Borrower Setup'
          handleClose={handleClose}
          dialogContent={
            <BorrowerSetupToDo
              borrowerId={borrowerId}
              loan={loan}
              handleClose={handleClose}
              refreshLoan={refreshLoan}
            />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          maxWidth={'lg'}
          open={open}
          title='Borrower Setup'
          handleClose={handleClose}
          dialogContent={
            <BorrowerSetupToDo
              borrowerId={borrowerId}
              loan={loan}
              handleClose={handleClose}
              refreshLoan={refreshLoan}
            />
          }
          removeContentBox
        />
      )}
    </>
  );
});

export default BorrowerSetupToDoDialog;